module.exports = __webpack_public_path__ + "img/LI-Logo.c24cde28.png";